module.exports = __webpack_public_path__ + "img/Social Security Fund.c94d5034.png";